<template lang="pug">
  form(id="touch-n-go-form" v-if="payment !== null")
    div.md-form-group(:class="{'invalid':errors.has('name')}")
      input.md-input(
        type="text"
        name="name"
        v-model="payment.name"
        v-validate="'required'"
        data-vv-as="Name"
        :disabled="loading"
        ref="paymentName"
      )
      label Name
      span.form-error-msg(v-show="errors.has('name')") {{ errors.first('name') }}

    div.md-form-group(:class="{'invalid':errors.has('touchngo_client_id')}")
      input.md-input(
        type="text"
        name="touchngo_client_id"
        v-model="payment.meta.touchngo_client_id"
        v-validate="'required'"
        data-vv-as="Client ID"
        :disabled="loading"
      )
      label Client ID
      span.form-error-msg(v-show="errors.has('touchngo_client_id')") {{ errors.first('touchngo_client_id') }}

    div.md-form-group(:class="{'invalid':errors.has('touchngo_client_secret')}")
      input.md-input(
        type="text"
        name="touchngo_client_secret"
        v-model="payment.meta.touchngo_client_secret"
        v-validate="'required'"
        data-vv-as="Client Secret"
        :disabled="loading"
      )
      label Client Secret
      span.form-error-msg(v-show="errors.has('touchngo_client_secret')") {{ errors.first('touchngo_client_secret') }}

    div.md-form-group(:class="{'invalid':errors.has('touchngo_merchant_id')}")
      input.md-input(
        type="text"
        name="touchngo_merchant_id"
        v-model="payment.meta.touchngo_merchant_id"
        v-validate="'required'"
        data-vv-as="Merchant ID"
        :disabled="loading"
      )
      label Merchant ID
      span.form-error-msg(v-show="errors.has('touchngo_merchant_id')") {{ errors.first('touchngo_merchant_id') }}

    div.md-form-group(:class="{'invalid':errors.has('touchngo_public_key')}")
      input.md-input(
        type="text"
        name="touchngo_public_key"
        v-model="payment.meta.touchngo_public_key"
        v-validate="'required'"
        data-vv-as="TNGD Public Key"
        :disabled="loading"
      )
      label Public Key
      span.form-error-msg(v-show="errors.has('touchngo_public_key')") {{ errors.first('touchngo_public_key') }}

    div.md-form-group(:class="{'invalid':errors.has('touchngo_product_code')}")
      input.md-input(
        type="text"
        name="touchngo_product_code"
        v-model="payment.meta.touchngo_product_code"
        v-validate="'required'"
        data-vv-as="Product Code"
        :disabled="loading"
      )
      label Product Code
      span.form-error-msg(v-show="errors.has('touchngo_product_code')") {{ errors.first('touchngo_product_code') }}

    div.md-form-group(:class="{'invalid':errors.has('touchngo_sftp_account')}")
      input.md-input(
        type="text"
        name="touchngo_sftp_account"
        v-model="payment.meta.touchngo_sftp_account"
        v-validate="'required'"
        data-vv-as="SFTP Account"
        :disabled="loading"
      )
      label SFTP Account
      span.form-error-msg(v-show="errors.has('touchngo_sftp_account')") {{ errors.first('touchngo_sftp_account') }}

    div.md-form-group(:class="{'invalid':errors.has('touchngo_sftp_account_password')}")
      input.md-input(
        type="text"
        name="touchngo_sftp_account_password"
        v-model="payment.meta.touchngo_sftp_account_password"
        v-validate="'required'"
        data-vv-as="SFTP Password"
        :disabled="loading"
      )
      label SFTP Password
      span.form-error-msg(v-show="errors.has('touchngo_sftp_account_password')") {{ errors.first('touchngo_sftp_account_password') }}

    div.md-form-group(:class="{'invalid':errors.has('sub_payment')}")
      select.md-input(
        v-model="payment.sub_payment"
        :disabled="loading"
      )
        option(v-for="type in types" :key="type.type" v-bind:value="type.type") {{ type.name }}
      label Mode

    div.md-form-group.p-t-0
      label.multiselect-label Applicable outlets
      multiselect(
        name="outlets"
        v-model="payment.outlets"
        :options="outletList"
        placeholder="Type to search"
        label="name"
        :multiple="true"
        :loading="outletList.length === 0"
        :disabled="loading"
        :clear-on-select="false"
        :close-on-select="false"
        :hide-selected="true"
        track-by="id"
      )
      span.md-input-msg Leave empty if applicable to all outlets.
    br
    div.md-form-group
      input.md-input(
        readonly
        type="text"
        placeholder="touch_n_go"
      )
      label Source
</template>

<script>
import FormMixin from '../form-mixin';
import types from './touch-n-go-types';

export default {
    mixins: [FormMixin],
    props: {
        payment: {
            type: Object,
            required: true,
            default: () => ({
                name: 'TouchNGo',
                type: 4,
                preset_amount: null,
                require_reference: true,
                source: 'touch_n_go',
                meta: {},
                outlets: [],
            }),
        },
    },

    data() {
        return {
            types: types,
        };
    },
    methods: {
        mapPaymentValue() {
            let payment = _.pick(this.payment, ['id', 'meta']);

            return Object.assign(payment, {
                name: this.payment.name,
                outlets: this.payment.outlets.map(obj => obj.id),
                type: 4,
                preset_amount: null,
                require_reference: true,
                require_drawer_kick: false,
                sub_payment: this.payment.sub_payment,
                source: 'touch_n_go',
            });
        },
    },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/franchise_component/setting/payment/custom/touch-n-go-form.vue